module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12 col-md-6\">\n\n    </div>\n    <div class=\"col-xs-12 col-md-6\">\n\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets/layout.two-equal-cols.html
// module id = 616
// module chunks = 0